export const markAllMessagesAsUnreadMutation = `
      mutation MarkAllMessagesAsUnread {
        markAllMessagesAsUnread
      }
    `;
